import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useGeneralApp } from '../../hooks/useGeneralApp'
import { data } from '../../data'
import { useAuth } from '../../hooks/useAuth'
import { MenuAuthenticated } from '../MenuAuthenticated'
import logo from '../../assets/navbar/logo.svg'
import './style.scss'

export const Navbar = () => {
  const { isAuthenticated } = useAuth()
  const { isLoading } = useGeneralApp()

  React.useEffect(() => {
    // console.log(isLoading)
  }, [isLoading])

  return (
    <header className="header navbar navbar-expand-lg primary-color sticky-top">
      <div className="container px-0">
        <Link to="/" className="navbar-brand ms-1">
        <img src={logo} width={40} alt="RAARR" className='ml-4'/>
        </Link>
        {
          !isLoading && (
            !isAuthenticated ? (<PublicButtons />) : <MenuAuthenticated/>
          )
        }
      </div>
    </header>

  )
}

const PublicButtons = () => {
  const location = useLocation()
  return (
    <>
      <ul className="navbar-nav me-auto ms-n4 ps-3 d-flex flex-row flex-nowrap overflow-auto ">
        {
          data
            .menuNavbar.espectador.options.map(
              op =>
                (
                <li key={op.id} className="nav-item ">
                  <Link to={op.pathname}
                    className={`nav-link btn button px-2 ${location.pathname === op.pathname && 'active'}`}>
                    {op.title}
                  </Link>
                </li>
                )
            )
        }
      </ul>
      <Link to={location.pathname === '/iniciar-sesion' ? 'registrarse' : 'iniciar-sesion'} className="btn btn-sm button primary-color fs-sm rounded px-2 me-3 me-md-4 ">
        {location.pathname === '/iniciar-sesion' ? 'Bienvenido' : 'Iniciar sesión'}
      </Link>
    </>
  )
}
